import { SET_CHANNELS } from '../../constants'

const initialState = {
  data: null,
  hasChannels: true,
}

export default function LiveChannelsReducer(state = initialState, action) {
  switch (action.type) {
    case SET_CHANNELS:
      return {
        ...state,
        data: action.payload,
        hasChannels: Array.isArray(action.payload) && action.payload.length > 0,
      }
    default:
      return state
  }
}
